export default "__VITE_ASSET__EBSrmDWs__"